<template>
	<div class="question-wrap">
		<CFullEmpty v-if="emptyData" class="empty-box" />
		<template v-else>
			<div class="question-list" v-for="(item, index) in tabData" :key="index">
				<div class="question-list__q">
					<img class="icon-svg" src="@/assets/images/irstore/icon-wenda.svg" alt="" />
					<span class="icon-title">{{ $t('enterprise.QA.question') }}</span>
					<span class="date font-Regular">{{ item.answerTime || item.questionTime || '-' }}</span>
				</div>
				<div class="inner">
					<div class="question-title">{{ item.question | removeBr }}</div>
					<div class="question-list_a">
						{{ item.answer | removeBr }}
					</div>
					<div v-if="!isEN" class="question-list__info">
						<span>{{ $t('enterprise.QA.resource') }}：{{ formatSource(item.sourceBiz) }}</span>
					</div>
				</div>
			</div>
		</template>
		<CFooterLoad ref="footerLoadObs" :more="hasMore" @load-more="loadMoreData" />
	</div>
</template>

<script>
import { irstore } from '@/fetch/interface';
import CFooterLoad from '@/view/enterprise/components/c-footer-load.vue';
import CFullEmpty from '@/view/enterprise/components/c-full-empty.vue';
import paginationMixin from '@/view/enterprise/mixins/paginationMixin';
import { mapGetters } from 'vuex';
import { getLanguageType, EN } from '@/assets/js/i18n';

export default {
	components: {
		CFooterLoad,
		CFullEmpty
	},
	mixins: [paginationMixin],
	props: {
		storeData: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	data() {
		return {};
	},
	computed: {
		...mapGetters(['getIrTemplateData', 'getIrFullCode']),

		isEN() {
			return this.$i18n.locale === EN;
		}
	},
	mounted() {
		// install mixins
		this.PAGINATION_LOAD = this.loadModule;
		this.PAGINATION_OBS_INSTALL = () => {
			this.$refs.footerLoadObs && this.$refs.footerLoadObs.install();
		};
		this.PAGINATION_OBS_UNINSTALL = () => {
			this.$refs.footerLoadObs && this.$refs.footerLoadObs.uninstall();
		};
	},
	methods: {
		formatSource(val) {
			const market = this.getIrFullCode?.slice(0, 2);
			if (market === 'sh' && val == '3') return '上交所';
			if (market === 'sz' && val == '3') return '深交所';
			let CODE_FILTER_NAME = {
				5: this.$t('enterprise.QA.tab.enquiry'),
				1: this.$t('enterprise.QA.tab.meeting'),
				4: this.$t('enterprise.QA.tab.activities')
			};
			return CODE_FILTER_NAME[val] || '-';
		},
		loadMoreData() {
			this.PAGINATION_LOAD_MORE();
		},
		refreshModule(query) {
			this.PAGINATION_REFRESH(query);
		},
		loadModule() {
			return this.$axios
				.post(irstore.postAdvisoryList, {
					fullCode: this.getIrFullCode,
					storeId: this.getIrTemplateData.storeId,
					pagestart: this.pageStart,
					pagenum: 20,
					sourceBiz: this.queryOptions.value || '',
					languageType: getLanguageType()
				})
				.then(res => {
					const result = res?.rows || [];
					this.PAGINATION_DATA_UPDATE(result);
					this.$emit('refresh');

					const total = res?.total || 0;
					const hasMore = this.tabData.length < total;
					return Promise.resolve(hasMore);
				})
				.catch(() => Promise.resolve(false));
		}
	}
};
</script>

<style lang="less" scoped>
.question-wrap {
	background: #f7f7f7;

	.empty-box {
		padding: 0.2rem 0;
	}
}
.question-list {
	margin-bottom: 0.1rem;
	padding: 0.1rem 0.14rem 0.12rem;
	font-family: 'PingFang SC';
	background: #fff;

	.inner {
		padding-left: 0.22rem;
	}
	.question-list__q {
		margin-bottom: 0.1rem;
		display: flex;
		align-items: center;
		.icon-svg {
			width: 0.16rem;
			height: 0.16rem;
		}
		.icon-title {
			margin-left: 0.08rem;
			font-size: 0.12rem;
			line-height: 0.17rem;
			color: #333;
		}
		.date {
			margin-left: 0.08rem;
			font-size: 0.11rem;
			line-height: 0.17rem;
			color: #666;
		}
	}
	.question-title {
		font-size: 0.15rem;
		line-height: 0.24rem;
		letter-spacing: 1px;
		color: #333;
	}
	.question-list_a {
		margin: 0.1rem 0;
		padding: 0.08rem 0.1rem;
		font-size: 0.15rem;
		line-height: 0.24rem;
		background: #f5f5f5;
		border-radius: 4px;
	}
	.question-list__info {
		font-size: 0.11rem;
		line-height: 0.15rem;
		color: #666;
	}
}
</style>
